export const confettiOptions = {
  particleCount: 200,
  spread: 80,
  origin: { y: 1.0 },
};

export const awardContainerSx = (theme) => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  margin: '0 auto',
  [theme.breakpoints.between('xs', 'sm')]: {
    maxWidth: '345px',
  },
  [theme.breakpoints.up('sm')]: {
    maxWidth: '80%',
    padding: '32px',
  },
});
